import {
  GET_LOGON_DETAILS_FAIL,
  GET_LOGON_DETAILS_REQUEST,
  GET_LOGON_DETAILS_SUCCESS,
  GET_LOGON_REQUESTS,
  GET_LOGON_REQUESTS_FAIL,
  GET_LOGON_REQUESTS_SUCCESS,
} from "src/constants/types";

export const logonRequestsReducers = (state = {}, actions) => {
  switch (actions.type) {
    case GET_LOGON_REQUESTS:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_LOGON_REQUESTS_SUCCESS:
      return {
        logonRequests: actions.payload,
        loading: false,
        error: "",
      };
    case GET_LOGON_REQUESTS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };
    case GET_LOGON_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };

    case GET_LOGON_DETAILS_SUCCESS:
      return {
        logonRequest: actions.payload,
        loading: false,
        error: "",
      };
    case GET_LOGON_DETAILS_FAIL:
      return {
        ...state,
        loading: false,
        error: actions.payload,
      };

    default:
      return state;
  }
};
